import React from 'react'

const ScenographicsLogo = props => {
  return (
    <g>
      <path d="M59.5 78.7l-1.1-.4C42.8 72 35.1 54.6 40.9 38.8c5.8-15.8 22.8-24.2 38.8-19l1.1.4-21.3 58.5zm10.6-58.2c-11.8 0-22.8 7.3-27.1 19-5.2 14.3 1.5 30 15.2 36.2l19.7-54.1c-2.6-.8-5.2-1.1-7.8-1.1z" />
      <path d="M49 102c-3.2 0-6.4-.5-9.6-1.5l-1.1-.4 21.3-58.6 1.1.4C76.3 48.3 84 65.6 78.2 81.5 73.6 94.1 61.8 102 49 102zm-7.8-3.4c14.5 4.1 29.7-3.6 34.9-18 5.2-14.3-1.4-30-15.2-36.2L41.2 98.6z" />
    </g>
  )
}

export default ScenographicsLogo
